import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { IProduct } from "@pbm/products/contracts";
import { Grid } from "@material-ui/core";
import {
  Button,
  GraphQLValidationErrors,
  TextField,
} from "@funcional/react-ui";
import { IGraphQLError } from "@common/contracts";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const containerSpacing = 3;

const schema = yup.object().shape({
  ean: yup
    .string()
    .required()
    .length(13)
    .matches(/^[0-9]*$/, "deve conter somente números."),
  name: yup.string().required().min(3, "deve ter pelo menos 3 letras"),
  brand: yup.string().required().min(3, "deve ter pelo menos 3 letras"),
  package: yup.string().required().min(3, "deve ter pelo menos 3 letras"),
  industryName: yup.string().required().min(3, "deve ter pelo menos 3 letras"),
  contentType: yup.string().required(),
  contentQuantity: yup.string().required(),
});

export default function ProductForm({
  onSubmit,
  defaults,
  isLoading,
  graphQLErrors,
}: {
  onSubmit: SubmitHandler<FieldValues>;
  defaults?: IProduct;
  isLoading?: boolean;
  graphQLErrors?: IGraphQLError[];
}) {
  const form = useForm({
    resolver: yupResolver(schema),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = form;

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-full max-w-xl">
      <GraphQLValidationErrors graphQLErrors={graphQLErrors} />
      <Grid container spacing={containerSpacing}>
        <Grid item xs={12}>
          <TextField
            required
            name="ean"
            label="EAN"
            control={control}
            defaultValue={defaults?.ean}
            errorMessage={errors?.ean?.message}
            helperText="Código de barras do produto"
            readOnly={defaults && defaults.ean ? true : false}
            transform={{
              input: (value: any) =>
                value ? value.toUpperCase().replace(/[^0-9]/g, "") : value,
              output: (e: any) =>
                e.target.value
                  ? e.target.value.toUpperCase().replace(/[^0-9]/g, "")
                  : e.target.value,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            required
            name="name"
            label="Nome"
            control={control}
            defaultValue={defaults?.name}
            errorMessage={errors?.name?.message}
            helperText="Nome do produto. Exemplo: FORXIGA 10MG"
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            required
            name="package"
            label="Embalagem"
            control={control}
            defaultValue={defaults?.package}
            errorMessage={errors?.package?.message}
            helperText="Apresentação do produto. Exemplo: FORXIGA 10MG 30CP REV"
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            required
            name="industryName"
            label="Indústria"
            helperText="Exemplo: ASTRA ZENECA REPOSIÇÃO"
            control={control}
            defaultValue={defaults?.industryName}
            errorMessage={errors?.industryName?.message}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            required
            name="brand"
            label="Marca"
            control={control}
            defaultValue={defaults?.brand}
            errorMessage={errors?.brand?.message}
            helperText="Nome do produto. Exemplo: FORXIGA"
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            required
            name="contentType"
            label="Tipo de conteúdo"
            control={control}
            defaultValue={defaults?.contentType}
            errorMessage={errors?.contentType?.message}
            helperText="Exemplo: comprimidos, cápsulas, envelopes, etc."
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            required
            name="contentQuantity"
            label="Quantidade da embalagem"
            control={control}
            defaultValue={defaults?.contentQuantity}
            errorMessage={errors?.contentQuantity?.message}
            helperText="Exemplo: 10, 20, 30 (cápsulas, MLs, etc.)"
          />
        </Grid>

        <Grid item xs={12}>
          <Button color="primary" type="submit" disabled={isLoading}>
            Salvar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
